exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2xZr_jQak4I8mhng_VKvQE {\n  padding-top: 100px;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n._3ap63tbl0Rczl7pAU9lqpB {\n  stroke-dasharray: 800;\n  -webkit-animation: _3RFJPOdK-cOHh5gPoB-DLB 2.5s infinite linear forwards;\n          animation: _3RFJPOdK-cOHh5gPoB-DLB 2.5s infinite linear forwards;\n}\n\n._2xZr_jQak4I8mhng_VKvQE h3 {\n  text-transform: none;\n  margin-top: 25px;\n  font-family: 'proxima-nova';\n  font-size: 22px;\n  color: silver;\n  letter-spacing: 0.06em;\n}\n\n@-webkit-keyframes _3RFJPOdK-cOHh5gPoB-DLB {\n  0% {\n    stroke-dashoffset: 800;\n  }\n  100% {\n    stroke-dashoffset: -800;\n\n  }\n}\n\n@keyframes _3RFJPOdK-cOHh5gPoB-DLB {\n  0% {\n    stroke-dashoffset: 800;\n  }\n  100% {\n    stroke-dashoffset: -800;\n\n  }\n}", ""]);

// exports
exports.locals = {
	"ecgLoader": "_2xZr_jQak4I8mhng_VKvQE",
	"pulse": "_3ap63tbl0Rczl7pAU9lqpB",
	"dash": "_3RFJPOdK-cOHh5gPoB-DLB"
};


//////////////////
// WEBPACK FOOTER
// /Users/travis/build/alivecor/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/travis/build/alivecor/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/EcgLoader/EcgLoader.css
// module id = 10263
// module chunks = 23